import axios from 'axios';
import Vue from 'vue';
import * as constants from '../constants';

export default {
  namespaced: true,

  state: {
    data: [],
    locations: [
      {id: 1, name: 'Depozit'},
      {id: 2, name: 'Tehnician'},
      {id: 3, name: 'Aparat'}
    ],
    status: [
      {id: 1, name: 'bună'},
      {id: 2, name: 'de test'},
      {id: 3, name: 'de aruncat'}
    ]
  },

  actions: {
    LOAD({ commit }, { filter }) {
      let params = {};
      let download = false;
      if (filter) {
        for (let key in filter) {
          if (filter.hasOwnProperty(key) && filter[key] !== null) {
            params[key] = filter[key];
          }
        }
        if (filter.sortBy) {
          params.order_by = `${filter.sortBy}:${filter.descending ? 'DESC' : 'ASC'}`;
        }

        delete params.sortBy;
        delete params.descending;
        delete params.totalItems;

        download = filter.hasOwnProperty('_download_');
        if (download) {
          params.rowsPerPage = -1;
        }
      }
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/stock`, {
          params,
          responseType: download ? 'arraybuffer' : 'json'
        })
          .then(response => response.data)
          .then(response => {
            if (!download) {
              commit('STOCK', response.data);
            }
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    LOAD_ONE({ commit }, id) {
      return new Promise((resolve, reject) => {
        axios.get(`${constants.SERVER_URL}/api/stock/${id}`)
          .then(response => response.data)
          .then(response => {
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    DELETE({ commit }, id) {
      commit('DELETE', id);
      return new Promise((resolve, reject) => {
        axios.delete(`${constants.SERVER_URL}/api/stock/${id}`)
          .then(response => {
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    EDIT({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios.put(`${constants.SERVER_URL}/api/stock/${data.id}`, data)
          .then(response => {
            commit('EDIT', response.data.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    },

    ADD({ commit }, data) {
      return new Promise((resolve, reject) => {
        delete data.id;
        axios.post(`${constants.SERVER_URL}/api/stock/`, data)
          .then(response => {
            commit('ADD', response.data.data);
            resolve(response);
          }, (error) => {
            reject(error);
          });
      });
    }
  },

  mutations: {
    STOCK(state, payload) {
      state.data = payload;
    },

    EDIT(state, payload) {
      const index = state.data.findIndex(item => item.id === payload.id);
      if (index > -1) {
        Vue.set(state.data, index, payload);
      }
    },

    ADD(state, payload) {
      state.data.unshift(payload);
    },

    DELETE(state, id) {
      const index = state.data.findIndex(item => item.id === id);
      if (index > -1) {
        state.data.splice(index, 1);
      }
    }
  },

  getters: {
    statusById: (state) => {
      const objectById = {};
      state.status !== null && state.status.forEach(item => {
        objectById[item.id] = item;
      });
      return objectById;
    },

    locationById: (state) => {
      const objectById = {};
      state.locations !== null && state.locations.forEach(item => {
        objectById[item.id] = item;
      });
      return objectById;
    },

    status: (state, getters) => (id) => getters.statusById[id] ? getters.statusById[id] : { name: '- Nedefinit -' },

    location: (state, getters) => (id) => getters.locationById[id] ? getters.locationById[id] : { name: '- Nedefinit -' }
  }
};



// WEBPACK FOOTER //
// ./src/store/stock.js